import * as React from 'react';

interface Props {
  url: string;
  locale: string;
  size: 'small' | 'large';
}

const langMap: { [key: string]: string } = {
  'en-US': 'en',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
};

export const LineShareButton = ({ url, locale, size }: Props) => {
  const [hasScript, setHasScript] = React.useState<boolean>(false);
  const [isButtonLoaded, setIsButtonLoaded] = React.useState<boolean>(false);

  const encodedUrl = encodeURI(url);

  const lang = langMap[locale || 'ja-JP'];

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://www.line-website.com/social-plugins/js/thirdparty/loader.min.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
    setHasScript(true);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const win = window as any;
    if (win.LineIt && hasScript && !isButtonLoaded) {
      win.LineIt.loadButton();
      setIsButtonLoaded(true);
    }
  }, [hasScript, isButtonLoaded]);

  return (
    <div>
      <div
        className="line-it-button"
        style={{ display: 'none' }}
        data-lang={lang}
        data-type="share-a"
        data-ver="3"
        data-url={encodedUrl}
        data-color="default"
        data-size={size}
        data-count="false"
      ></div>
    </div>
  );
};
